import {Component, OnInit} from '@angular/core';
import {CompetitionFilter, CompetitionModel} from '../../models/competition/competition.model';
import {Router} from '@angular/router';
import {EVOCompetitionListSort} from '../../shared/list-views/evo-competition-list-view/evo-competition-list-view.component';
import {Enums} from '../../models/extensions/enums';
import {AdminCompetitionService} from '../../services/admin/admin-competition.service';
import {ModalService} from '../../shared/modals/modal/modal.service';
import {ErrorModel} from '../../models/shared/error.model';
import {CountryModel} from '../../models/localization-and-pricing/country.model';

@Component({
  selector: 'app-admin-competitions',
  templateUrl: './admin-competitions.component.html',
  styleUrls: ['./admin-competitions.component.css']
})
export class AdminCompetitionsComponent implements OnInit {

  competitions: CompetitionModel[] = [];
  competitionFilter = new CompetitionFilter();
  hasMoreData = true;

  newCompetition = new CompetitionModel();
  showCreateCompetition = false;

  // School competitions cannot be created, they are not a type the backend accepts
  competitionTypesDropdownList = Enums.CompetitionTypes.dropdownList().filter((item) => item.key !== Enums.CompetitionTypes.school);
  allCountries = CountryModel.privateList();

  constructor(private router: Router,
              private modalSv: ModalService,
              private competitionSv: AdminCompetitionService) {
  }

  ngOnInit() {

    this.competitionFilter.skip = 0;
    this.competitionFilter.limit = 20;
    this.onFetchMoreCompetitions();

  }

  searchFilteredCompetitions(searchString: string) {

    this.competitionFilter.skip = 0;
    this.competitionFilter.name = searchString;
    this.competitionFilter.sortByName = 1;
    this.hasMoreData = true;

    this.competitions = [];

    this.onFetchMoreCompetitions();

  }

  onFetchMoreCompetitions() {

    this.competitionFilter.skip = this.competitions.length;
    this.competitionSv.fetchCompetitions(this.competitionFilter).subscribe((competitions) => {
      console.log('has more data: ' + this.hasMoreData);
      this.hasMoreData = this.competitionFilter.limit === competitions.length;
      this.competitions.addUniqueArrayElements(competitions);

    });
  }

  onCompetitionClicked(competition: CompetitionModel) {

    if (competition) {
      this.router.navigate(['admin', 'competitions', competition._id, 'detail', 'dashboard']);
    }

  }

  onCompetitionViewClicked(competition: CompetitionModel) {

    if (competition) {
      this.router.navigate(['admin', 'competitions', competition._id, 'preview']);
    }

  }

  onSortChanged(sort: EVOCompetitionListSort) {

    if (sort.key === 'name') {
      this.competitionFilter.sortByName = sort.value;
    } else if (sort.key === 'startAt') {
      this.competitionFilter.sortByStartAt = sort.value;
    } else if (sort.key === 'endAt') {
      this.competitionFilter.sortByEndAt = sort.value;
    }

    this.competitionFilter.skip = 0;
    this.competitions = [];
    this.onFetchMoreCompetitions();

  }

  onCreateCompetition() {

    if (this.newCompetition.isConsumer() && this.newCompetition.countries.length === 0) {
      this.modalSv.showAlertModal('Countries required', 'Select at least one country for a consumer competition.', 'Ok');
      return;
    }

    this.competitionSv.createCompetition(this.newCompetition).subscribe((createdCompetition) => {

      this.competitions = [];
      this.onFetchMoreCompetitions();
      this.showCreateCompetition = false;
      this.newCompetition = new CompetitionModel();

    }, (err: ErrorModel) => {

      this.modalSv.showTranslatedErrorModal(err);

    });

  }

}
